function textClamp(){
    const textClampBlocks= document.querySelectorAll('.text-clamp');
    textClampBlocks.forEach(textClampBlock => {
        showReadMoreButton(textClampBlock);
    });
    function showReadMoreButton(element){
        if (element.offsetHeight < element.scrollHeight || element.offsetWidth < element.scrollWidth) {
            const readMoreButton = document.createElement("button");
            readMoreButton.innerText = 'Показать еще...';
            readMoreButton.classList.add("readMoreButton");

            readMoreButton.addEventListener('click', (event) => {
                event.preventDefault();
                element.classList.remove('text-clamp');
                readMoreButton.remove();
            });

            if(!element.nextElementSibling || (element.nextElementSibling && !element.nextElementSibling.classList.contains('readMoreButton')) ){
                element.after(readMoreButton);
            }
        }
    }
}

export default textClamp;